module.exports = __webpack_public_path__ + "img/logoSaleNoti.f3d3b02c.png";